// Profile of Nikolai Genov, Ukrainian. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • охорона здоров’я, науки про життя, фінанси',
  summary: 'Біоінформатик зі ступенем PhD і технічний керівник-практик, який поєднує розробку програмного забезпечення з підтримкою ШІ та аналітику в регульованих галузях: охороні здоров’я, науках про життя та фінансах. Фахова компетентність охоплює LLM/RAG-системи, інтеграцію MCP, клінічні дані, п’ятирічні банківські прогнози та автоматизовану звітність в Excel. Поєднує розробку на R/Python з координацією команди, забезпеченням якості та воркшопами на рівні керівництва компаній; має сертифікацію з AI Act і пройшов навчання з GCP.',
  imageAlt: 'Портрет Nikolai Genov',
  personal: {
    position: 'Співзасновник і керуючий директор pAIoneer Labs GmbH, керуючий директор Leap Dynamics GmbH',
    location: 'Берлін, Німеччина',
    languages: 'Німецька та англійська (вільно), болгарська (вільно)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Сертифікація з AI Act, навчання з GCP (2025)',
    publications: 'Рецензовані наукові праці в Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology та PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Здобуття докторського ступеня: біоінформатика / теоретична біологія',
      institution: '',
      degree: 'Ступінь: PhD (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Навчання: біоінформатика',
      institution: 'Freie Universität Berlin',
      degree: 'Ступінь: M.Sc. з біоінформатики'
    },
    {
      period: '2012',
      field: 'Навчання: біоінформатика',
      institution: 'Freie Universität Berlin',
      degree: 'Ступінь: B.Sc. з біоінформатики'
    }
  ],
  skills: [
    {
      title: 'Ключові компетенції',
      description: 'Розробка з підтримкою ШІ, R/Python, LLM/RAG і MCP, клінічні дані та біоінформатика, прогнозування та стрес-тестування, звітність в Excel, Shiny, технічне керівництво'
    },
    {
      title: 'Програмування та аналітика',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Застосунки та звітність',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; автоматизована звітність у форматах Excel/Word/PDF'
    },
    {
      title: 'ШІ та інтеграція',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; розробка з підтримкою ШІ та перевіркою людиною'
    },
    {
      title: 'Інженерія',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Біоінформатика',
      description: 'RNA-seq, мікрочипи, альтернативний сплайсинг/ізоформи, аналіз збагачення наборів генів, аналіз сигнальних шляхів і мереж, складання геному, аналіз виживаності; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Клінічні дані',
      description: 'EDC, CRF, перевірки даних (edit checks), DMP, плани валідації даних, UAT, звірка SAE; CDISC SDTM/ADaM, пайплайни RAW/SDTM/ADaM, QC'
    }
  ],
  positions: [
    {
      period: '2022 - квітень 2024',
      title: 'Автоматизація звітності, T-Systems / Європейський центральний банк (ЄЦБ)',
      description: [
        'Розробка R-бібліотеки для статистичної звітності за фінансовими часовими рядами; міграція логіки FAME на R/Python за допомогою Reticulate та автоматизація формування документів Word/PDF.',
        'Розробка пайплайнів для автоматизованого формування Excel-звітів; інтеграція аналітики з Camunda, підтримка GitLab CI/CD, модульних тестів, лінтингу, SonarQube та документації.',
        'Заміщення керівника команди, участь у плануванні спринтів, технічній координації, забезпеченні якості та взаємодії із зацікавленими сторонами.'
      ]
    },
    {
      period: 'Червень 2025 - грудень 2025',
      title: 'Data Science & Risk Analytics Consultant, банківська сфера',
      description: [
        'Розробка прогнозних моделей із горизонтами планування до п’яти років і впровадження стрес-тестів.',
        'Переписування та рефакторинг успадкованого R-коду, оптимізація чотирьох бізнес-процесів; розробка з підтримкою ШІ та перевіркою людиною для реалізації й документації.',
        'Створення аналітичних робочих процесів на R/Shiny і пайплайнів для автоматизованого формування Excel-звітів; втілення бізнес-вимог в аналітичних рішеннях.'
      ]
    },
    {
      period: 'Червень 2025 - червень 2026',
      title: 'Clinical Data Manager, фармацевтика / клінічні дослідження',
      description: [
        'Керування налаштуванням EDC, розробкою CRF, перевірками даних (edit checks), ролями користувачів, специфікаціями передавання даних і UAT; координація з CRO, лабораторіями та дослідницькими командами.',
        'Створення та рецензування DMP, планів валідації, планів звірки SAE та UAT-документації; розробка валідаційних робочих процесів на R і Shiny-застосунків у середовищі, де діють вимоги GCP.'
      ]
    },
    {
      period: 'Липень 2026',
      title: 'Пайплайн клінічних даних, Dr. Falk Pharma',
      description: [
        'Побудова пайплайна RAW/SDTM/ADaM на R з використанням OpenCode і розробки з підтримкою ШІ — з валідацією, QC, простежуваністю та пайплайнами автоматизованих Excel-звітів.'
      ]
    },
    {
      period: '2026',
      title: 'Звітність за журналом аудиту (audit trail) з підтримкою ШІ, Miltenyi Biotec',
      description: [
        'Реалізація звітів за журналом аудиту та пайплайнів автоматизованих Excel-звітів з використанням OpenCode і розробки з підтримкою ШІ, включно з логікою звітів, налагодженням, документацією та перевіркою людиною.'
      ]
    },
    {
      period: 'З 2019 року',
      title: 'Керуючий директор і співзасновник / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Керівництво консалтингом і технічною реалізацією у сферах охорони здоров’я, наук про життя, фінансів та ШІ; поєднання власної практичної розробки з координацією команди та комунікацією із зацікавленими сторонами.',
        'Проєктування LLM/RAG-інфраструктури та інтеграції інструментів на основі MCP. Запровадження робочих процесів розробки на R/Python з підтримкою OpenCode для генерації коду, рефакторингу, тестування та документування з перевіркою людиною.'
      ]
    },
    {
      period: 'З 2022 року',
      title: 'Канцер-реєстр і біобанк, Medical University Pleven',
      description: [
        'Аналіз даних національного канцер-реєстру та створення Shiny-дашбордів для клінічних і наукових зацікавлених сторін; підтримка інтеграції, документації та біобанкових робочих процесів для п’яти видів раку.'
      ]
    },
    {
      period: 'З 2025 року',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Створення готового до промислової експлуатації застосунку на R Shiny; міграція даних із CSV до SQLite, додавання автентифікації адміністратора, керування установами, аналітики відвідувань, платних записів і форм запитів зі сповіщеннями через SMTP.',
        'Покращення адаптивного UI/UX, SEO, структурованих даних і підтримки sitemap/robots; додавання валідації введених даних, екранування виводу, обмеження частоти спроб входу та показу лише перевірених публічних записів. Перевірка понад 400 установ за даними ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT та AI-on-Demand з документацією щодо походження даних, розгортання та безпеки.'
      ]
    },
    {
      period: 'З 2024 року',
      title: 'Аналітика фінансових новин на основі LLM, Leap Dynamics (внутрішній проєкт)',
      description: [
        'Побудова робочих процесів регулярного аналізу тональності з використанням LLM, даних з API, автоматизованих PDF-звітів, інтерфейсу на Streamlit, оркестрації в n8n і тестування робочих процесів за допомогою Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Воркшопи на рівні керівництва компаній, BVMW',
      description: [
        'Проведення воркшопів для учасників рівня керуючих директорів у мережі BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Науковий співробітник, Humboldt-Universität / Charité, Берлін',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO і співзасновник, Promethano GmbH',
      description: [
        'Програмне забезпечення та застосунки для роботи з часовими рядами для наук про життя.'
      ]
    }
  ]
};
